import React, { Component, Fragment } from 'react';
import { Link, Redirect } from "react-router-dom";
import BackArrow from '../../assets/img/welcomepage/TopbarIcons/back-arrow.png';
const backdropStyle = {
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: 'rgba(31,27,27,0.95)',
  padding:0
};

class eChargeSlip extends Component {
  state = { isOpen: false ,eChargeSlipUrl:''}
componentDidMount(){
let SlipUrl ="https://totalemi.innoviti.com:30011/eslip" + this.props.eSlipUri.split("eslip")[1];
this.setState({eChargeSlipUrl:SlipUrl})
}
  render () {
    return (
      <>
      <div style={backdropStyle}>
      <div style={{background:'#f5f5f5',textAlign:'center'}}>
      <img src={BackArrow} style={{ float: 'left', height:'25px',display:'inline-block' }} onClick={()=>this.props.showModal()} />
      <p style={{margin:'0px',display:'inline-block',color:'#666666',fontSize:'16px',textAlign:'center',paddingRight:'20px'}}>eCharge Slip</p>
      </div>
      <iframe src={this.state.eChargeSlipUrl} style={{width:'100%',height:'100%'}} frameBorder="0"/>
      </div>
      </>
    )
  }
}
export default eChargeSlip;